import {channelEnum} from "../domains2/types/EnumTypes";
import SectionHeaderElement from "../domains2/products/SectionHeaderElement";
import GridBlockElement from "../domains2/products/GridBlockElement";
import {NodeElements} from "../domains2/products/ProductTypes";
import AppError from "../domains2/libraries/AppError";
import * as mutationTypes from "../store/mutation-types";
import {
	DeliveryMethodsEnum,
	getDeliveryMethodByNumberValue
} from "../domains2/libraries/DeliveryMethods";

import { shouldCartBeEmptied } from "../helper/DeliveryMethodsHelper";
import apmTracker, {
	CUSTOM_APM_SPAN_NAMES,
	CUSTOM_APM_TRANSACTION_KEYS,
	CUSTOM_APM_TRANSACTION_NAMES
} from "./ApmTrackingHelper";
import { filterCurrentUserFavoriteProductListByShopId, calculateUnavailableSelections } from "../libraries/utils";
import { getUsedCampaigns } from "../libraries/globalTemplateSpecific/bm100/utils";
import CategoryHelper from "./CategoryHelper";

export const applyActionForElementsItems = (data, callback, callbackParams) => {
	const sectionValue = +callbackParams.section;
	const section = data.elements[sectionValue];
	if (!section) {
		return;
	}
	if (section.objType === "GridBlockElement") {
		callback(data.elements[sectionValue].items, callbackParams, section.objType);
		if (callbackParams.isRawObjectAction) {
			delete callbackParams.isRawObjectAction;
			callback(data.rawObject.elements[sectionValue].items, callbackParams, section.objType);
		}
	} else if (section.objType === "ProductCatalogList") {
		callback(data.elements[sectionValue].props.products, callbackParams, section.objType);
	}
};

export const removeElementsItems = (items, params) => {
	if (!("itemIndex" in params)) {
		throw new Error("Invalid Data");
	}
	items.splice(params.itemIndex, 1);
};

export const orderElementsItems = (items, params) => {
	if (!("itemIndex" in params) || !("position" in params)) {
		throw new Error("Invalid Data");
	}
	const itemIndex = +params.itemIndex;
	let position = +params.position;
	if (position < 0) {
		position = 0;
	}
	if (position > items.length - 1) {
		position = items.length - 1;
	}
	const element = items[itemIndex];
	items.splice(itemIndex, 1);
	items.splice(position, 0, element);
};

export const addProductToElementsItem = (items, params, objType) => {
	let newProduct;
	if (params.isRawObjectAction) {
		newProduct = params.productData;
	} else {
		newProduct = objType === "GridBlockElement" ? {id_ref: params.id} : params.id;
	}
	items.push(newProduct);

	if ("position" in params) {
		orderElementsItems(items, {itemIndex: items.length - 1, position: params.position});
	}
};

export const addImageToElementsItems = (items, params) => {
	const newImage = {
		objType: "InfoBlock",
		imageLink: params.imageUrl
	};
	items.push(newImage);

	if ("position" in params) {
		orderElementsItems(items, {itemIndex: items.length - 1, position: params.position});
	}
};

export const applyActionForElements = (data, callback, callbackParams) => {
	callback(data.elements, callbackParams);
	callback(data.rawObject.elements, callbackParams);
};

export const setCategoriesToElements = (elements, params) => {
	elements.splice(0, elements.length, ...params);
};

export const addTitleToElements = (elements, params) => {
	const newElement = {
		objType: "SectionHeaderElement",
		name: params.name,
		... (params.description ? {description: params.description} : {}),
		... (params.routerLink ? {routerLink: params.routerLink} : {})
	};
	elements.push(newElement);

	if ("position" in params) {
		orderElementsItems(elements, {itemIndex: elements.length - 1, position: params.position});
	}
};

export const editTitleElements = (elements, params) => {
	if (!("section" in params)) {
		return;
	}
	const element = elements[params.section];
	element.name = params.name;
	element.description = params.description;
	element.routerLink = params.routerLink;
	if ("position" in params && params.section !== params.position) {
		orderElementsItems(elements, {itemIndex: params.section, position: params.position});
	}
};

export const addParagraphToElements = (elements, params) => {

	const newElement = {
		objType: "StaticInfoBlock",
		description: params.description,
		plainText: true
	};
	elements.push(newElement);

	if ("position" in params) {
		orderElementsItems(elements, {itemIndex: elements.length - 1, position: params.position});
	}
};

export const editParagraphElements = (elements, params) => {
	if (!("section" in params)) {
		return;
	}
	const element = elements[params.section];
	element.description = params.description;

	if ("position" in params && params.section !== params.position) {
		orderElementsItems(elements, {itemIndex: params.section, position: params.position});
	}
};

export const addFaqElements = (elements, params) => {
	const newElement = {
		objType: "FaqMarkup",
		content: params.content
	};
	elements.push(newElement);

	if ("position" in params) {
		orderElementsItems(elements, {itemIndex: elements.length - 1, position: params.position});
	}
};

export const editFaqElements = (elements, params) => {
	if (!("section" in params)) {
		return;
	}
	const element = elements[params.section];
	element.content = params.content;

	if ("position" in params && params.section !== params.position) {
		orderElementsItems(elements, {itemIndex: params.section, position: params.position});
	}
};


export const addImageToElements = (items, params) => {
	const newImage = {
		objType: "SectionHeaderElement",
		imageLink: params.imageUrl,
		... (params.routerLink ? {routerLink: params.routerLink} : {})
	};
	items.push(newImage);

	if ("position" in params) {
		orderElementsItems(items, {itemIndex: items.length - 1, position: params.position});
	}
};

export const addProductToElements = (items, params) => {
	if (!("products" in params)) {
		return;
	}
	const products = params.products.map((product) => { return {id_ref: product.id}; });
	const newProduct = {
		items:products,
		objType: "GridBlockElement",
		template: "T3c"
	};
	items.push(newProduct);

	if ("position" in params) {
		orderElementsItems(items, {itemIndex: items.length - 1, position: params.position});
	}
};

export const mapElementsForKiosk = (elements, productCatalog) => {
	return elements.map((node) => {
		if (node.objType === "SectionHeaderElement") {
			return new SectionHeaderElement(node);
		} else if (node.objType === "GridBlockElement") {
			return new GridBlockElement(node, productCatalog.mapper, productCatalog.productCache);
		} else if (NodeElements.includes(node.objType)) {
			return node;
		} else {
			throw AppError.CodingError("Should never happen: ").addData(
				"node",
				node
			);
		}
	});
};

export const addCarouselToElements = (items, params) => {
	if (!("products" in params)) {
		return;
	}
	const products = params.products.map((product) => { return {id_ref: product.id}; });
	const newProduct = {
		items:products,
		objType: "GridBlockElement",
		template: "T3d",
		... params.title ? {title: params.title} : {}
	};
	items.push(newProduct);

	if ("position" in params) {
		orderElementsItems(items, {itemIndex: items.length - 1, position: params.position});
	}
};

export const getCategories = (categories, channelAlias, globalSelectedShopId) => {
	return [...categories].filter((cat) => {
		if (Array.isArray(cat.isSpecificForShops)) {
			return (
				cat.isSpecificForShops.includes(globalSelectedShopId)
					&& cat.isActive === true
					&& cat.channels.includes(channelAlias)
			);
		}
		return (
			cat.isActive === true && cat.channels.includes(channelAlias)
		);
	})
		.sort((p1, p2) => {
			return parseInt(p1.menuPosition) - parseInt(p2.menuPosition);
		});
};

export const calculateDefaultCategoryId = (categories, channelAlias, globalSelectedShopId) => {
	const filteredAndSortedCategories = getCategories(categories, channelAlias, globalSelectedShopId);
	return filteredAndSortedCategories[0].extId.toString();
};

export function isGBOKioskCategoryModel(node, currentChannelAlias) {
	return (
		node.channels && node.channels.includes(channelEnum.kiosk) &&
			currentChannelAlias.toLowerCase() === channelEnum.kiosk.toLowerCase() &&
		[...node.elements].every(
			(element) =>
				!!element.props &&
				!!element.objType &&
				element.objType === "ProductCatalogList"
		)
	);
}

export const goToCategories = async (payload) => {
	const deliveryChoice = payload.deliveryChoice || payload.$store.getters.tenantSpecificData.deliveryChoice;
	apmTracker.start(
		CUSTOM_APM_TRANSACTION_KEYS.PRODUCT_CATALOG_TRANSITION,
		CUSTOM_APM_TRANSACTION_NAMES.DELIVERY_METHODS_TO_PRODUCT_CATALOG_TRANSITION,
		CUSTOM_APM_SPAN_NAMES.DELIVERY_METHOD_CLICKED
	);
	if (!payload.featureToggles.enableNewChangeRestaurant) {
		const emptyCart = shouldCartBeEmptied(deliveryChoice, payload.oldDeliveryChoice);
		if (emptyCart || !payload.oldDeliveryChoice) {
			payload.$store.dispatch(mutationTypes.CART_EMPTY_ALL);
		}
	}
	const promises = [];
	if (payload.featureToggles.useNewProductCatalog || payload.featureToggles.enableNewChangeRestaurant) {
		payload.isLoadingProductCatalog = true;
		const deliveryMethodRef = getDeliveryMethodByNumberValue(deliveryChoice);
		promises.push(payload.$store.dispatch("refreshProductCatalog", {
			deliveryMethod: deliveryMethodRef,
			invalidateCache: true
		}));
	}
	if (payload.featureToggles.productTagsFilter) {
		promises.push(payload.$store.dispatch(mutationTypes.FETCH_PRODUCT_TAGS));
	}
	const resultArr = await Promise.all(promises);
	const productCatalogObj = (resultArr || []).find((item) => item && item.productCatalog);
	if(payload.$store.getters.applicationUserLoggedIn && payload.$store.getters.isSunsetPointsMember) {
		const usedCampaigns = await getUsedCampaigns();
		payload.$store.commit(mutationTypes.SET_USER_META_USED_CAMPAIGNS, usedCampaigns);
	}

	payload.$store.commit(mutationTypes.SET_QR_CODE_TABLE_SERVING_DATA, {});
	if (deliveryChoice === DeliveryMethodsEnum.DELIVERY) {
		payload.$router.push("/address-selection");
	} else if (deliveryChoice === DeliveryMethodsEnum.DRIVE_IN) {
		payload.$router.push("/booth-number");
	} else {
		// we already have product catalog in this context, there is no need to rely on store getter
		// it can be used as fallback though
		const productCatalog = (productCatalogObj && productCatalogObj.productCatalog) || payload.$store.getters.getNonCachedProductCatalog();
		const firstCategoryId = CategoryHelper.getFilteredCategories({
			hideToolbar: false,
			isReorderState: payload.$store.getters.isReorderState,
			isLoggedIn: payload.$store.getters.applicationUserLoggedIn,
			getFavouriteProducts: filterCurrentUserFavoriteProductListByShopId(
				payload.$store.getters.favoriteProducts,
				productCatalog,
				payload.$store.getters.globalSelectedShop.id,
				payload.$store.getters.cachedPickupRules
			),
			hiddenItems: [],
			getIconUrl: () => {},
			fetchedProductCatalog: productCatalog
		})[0].extId;
		payload.$store.dispatch(mutationTypes.ADD_ORDER_TAGS_BASED_ON_PICKUP_OPTION);
		if (payload.featureToggles.enableNewChangeRestaurant && (payload.selections || []).length > 0) {
			await calculateUnavailableSelections({
				selections: payload.selections,
				globalSelectedShopId: payload.$store.getters.globalSelectedShop.id,
				cachedPickupRules: payload.$store.getters.cachedPickupRules,
				$store: payload.$store,
				productCatalog,
				deliveryChoice
			});
		}
		payload.$router.push(`/category/${firstCategoryId}`);
	}
	payload.$store.commit(mutationTypes.SET_SELECTED_DEAL_ID);
};
